/* eslint-disable import/prefer-default-export */
export const getGenericBanner = (uid) =>
  `v1/uplus/generic-banner/banner_details/?banner_uid=${uid}`;
